import formatCurrency from "./formatCurrency";
import { toMajorUnits } from "./toMajorUnits";

// Formats an amount in a currency's minor unit — cents for USD, whole rupees
// for INR — so callers never divide by 100 themselves.
export const formatMinorAmount = (amount: number, currency?: string) =>
  formatCurrency(toMajorUnits(amount, currency), currency, {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
